import { render, staticRenderFns } from "./GalleryIntro.vue?vue&type=template&id=638401b1&scoped=true&"
import script from "./GalleryIntro.vue?vue&type=script&lang=ts&"
export * from "./GalleryIntro.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryIntro.vue?vue&type=style&index=0&id=638401b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638401b1",
  null
  
)

export default component.exports